import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Layout from "../../components/layout";
import DevFeedbackList from "../../components/devFeedback/DevFeedbackList";
import { useAppSelector } from "../../app/hooks";
import { getLoggingUser } from "../../features/loggingUser/loggingUserSlice";
import { getSelectedBranch } from "../../features/settings/settingsSlice";
import { useCanAccess } from "../../hooks/useCanAccess";
import { t } from "../../locales";
import { route } from "../../static/route";

const DevFeedbackPage = () => {
  const navigate = useNavigate();
  const canAccess = useCanAccess();
  const loggingUser = useAppSelector(getLoggingUser);
  const selectedBranch = useAppSelector(getSelectedBranch);

  useEffect(() => {
    if (
      loggingUser?.permissions &&
      selectedBranch &&
      !canAccess("dev-feedback")
    ) {
      navigate(route.dashboard);
    }
  }, [loggingUser, selectedBranch]);

  return (
    <Layout>
      <div className="px-6 py-6">
        <nav className="text-sm font-semibold text-gray-500 mb-4">
          <Link to={route.dashboard} className="text-brand-dark hover:underline">
            {t.devFeedback.breadcrumbHome}
          </Link>
          <span className="mx-2">&rsaquo;</span>
          <span className="text-gray-500">{t.devFeedback.breadcrumbDevFeedback}</span>
        </nav>

        <h1 className="text-2xl font-bold text-brand-dark mb-6">
          {t.devFeedback.pageTitle}
        </h1>

        <DevFeedbackList />
      </div>
    </Layout>
  );
};

export default DevFeedbackPage;
